import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../core/interceptor/http-interceptor-config";
import Api from "../core/api/api";

let postSummaryController = new AbortController();

export const postSummary = createAsyncThunk(
  "summarize/postQuickSummary",
  async (data: any) => {
    // Create a new AbortController for this request
    postSummaryController = new AbortController();
    return await axiosInstance.post(Api.summarize, data, {
      signal: postSummaryController.signal,
    });
  }
);

export const getSummaryChart = createAsyncThunk(
  "summarize/getSummaryChart",
  async () => {
    return await axiosInstance.get(
      Api.summarize_chart
    );
  }
);

export const getSummaryKPI = createAsyncThunk(
  "summarize/getSummaryKPI",
  async () => {
    return await axiosInstance.get(
      Api.summary_kpi
    );
  }
);

export const getSummaryTypes = createAsyncThunk(
  "summarize/getSummaryTypes",
  async () => {
    if (postSummaryController) postSummaryController.abort();
    return await axiosInstance.get(Api.summary_types);
  }
);

export const getSummaryStatus = createAsyncThunk(
  "summarize/getSummaryStatus",
  async (summary_id: any) => {
    return await axiosInstance.get(
      Api.summarize_status + "?summary_id=" + summary_id
    );
  }
);

export const getSummaryList = createAsyncThunk(
  "summarize/getSummaryList",
  async (data: string) => {
    return await axiosInstance.get(Api.summarize + data);
  }
);

export const getSummaryDetails = createAsyncThunk(
  "summarize/getSummaryDetails",
  async (summaryId: string = "") => {
    return await axiosInstance.get(Api.summarize + "?summary_id=" + summaryId);
  }
);

export const deleteSummaryDetail = createAsyncThunk(
  "summarize/getSummaryDetails",
  async (summaryId: string = "") => {
    return await axiosInstance.delete(Api.summarize + "?summary_id=" + summaryId);
  }
);
